// src/components/LoadingScreen.jsx
import React from "react";
import "./LoadingScreen.css";
import logo from "../../assets/images/logo.png"; // adjust the path if needed

const LoadingScreen = () => {
  return (
    <div className="loading-wrapper">
      <div className="loading-content">
        <img src={logo} alt="Loading..." className="loading-logo" />
        <div className="loading-spinner"></div>
        <p className="loading-text">Loading, please wait...</p>
      </div>
    </div>
  );
};

export default LoadingScreen;
